export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          联系我们
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          漫画投稿、商务合作或意见反馈，欢迎随时联系我们
        </p>
        <div className="max-w-[700px] mx-auto bg-background-50 rounded-2xl p-8 md:p-10 text-center">
          <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-5">
            <i className="ri-mail-send-line text-2xl text-primary-600"></i>
          </div>
          <h3 className="font-heading text-xl text-foreground-900 mb-3">
            投稿与合作咨询
          </h3>
          <p className="text-foreground-600 text-sm leading-relaxed mb-6 max-w-md mx-auto">
            如果你有原创漫画想要投稿，或是寻求商务合作、广告投放，欢迎通过以下方式与我们取得联系。我们期待与更多优秀的漫画创作者和合作伙伴携手。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:contact@xingqiumanhua.com"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              发送邮件
            </a>
            <span className="text-foreground-500 text-sm">
              或添加商务微信：xingqiu_mh
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}